import React__default from "react";
const isComponent = (element, type) => React__default.isValidElement(element) && element.type === type;
const isComponentWithChildren = (element) => React__default.isValidElement(element);
function isComponentWithDisplayName(element, displayName) {
  if (!React__default.isValidElement(element) || typeof element.type === "string") {
    return false;
  }
  const componentType = element.type;
  return componentType.displayName === displayName;
}
export {
  isComponent,
  isComponentWithChildren,
  isComponentWithDisplayName
};
//# sourceMappingURL=component.js.map
